import { InterruptionTypeModel, InterruptionTypeModelAPI } from '../../../../models';

export const getInterruptionTypesListAdapter = (
    responseAPI: InterruptionTypeModelAPI[]
): InterruptionTypeModel[] => {
    return responseAPI
        ? responseAPI.map((interruptionType) => {
              return {
                  id: interruptionType.id,
                  isActive: interruptionType.isActive,
                  name: interruptionType.name,
                  defaultTime: interruptionType.defaultTime,
                  isPaid: interruptionType.isPaid,
              };
          })
        : [];
};
